module.exports = __webpack_public_path__ + "img/cooper.3165f086.png";